import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalController, PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-popover-iframe',
  templateUrl: './popover-iframe.component.html',
  styleUrls: ['./popover-iframe.component.scss'],
})
export class PopoverIframeComponent {
  @Input() data: any;
  public title:string = "";
  public url:string = "";
  public iFrameURL:any;
  
  constructor(
    public viewCtrl: ModalController, 
    private sanitizer: DomSanitizer,
    public popOverCtrl: PopoverController
  ) {
    this.title = this.data.title ? this.data.title : "";
    const url = this.data.url;
    this.iFrameURL = url ? this.sanitizer.bypassSecurityTrustResourceUrl(url) : null;
  }

  closePopover() {
    this.popOverCtrl.dismiss( false);
  }
}